import { render, staticRenderFns } from "./trigerItem.vue?vue&type=template&id=25e47bbb&scoped=true&"
import script from "./trigerItem.vue?vue&type=script&lang=js&"
export * from "./trigerItem.vue?vue&type=script&lang=js&"
import style0 from "./trigerItem.vue?vue&type=style&index=0&id=25e47bbb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e47bbb",
  null
  
)

export default component.exports